export const VOICE_TYPES = Object.freeze({ direction: 'direction', dialogue: 'dialogue' });
export const DIRECTION_DIALOGUE_PAUSE_MS = 360;

export function didPrivatePromptPlay(audioMode, playbackResult) {
  return audioMode === 'text' || playbackResult === true;
}

export function voiceTypeForPrompt(prompt = {}, requestedChannel) {
  if (requestedChannel === 'direction' || requestedChannel === 'dialogue') return requestedChannel;
  return prompt.dialogueText || prompt.type === 'dialogue' || prompt.cueVoice ? VOICE_TYPES.dialogue : VOICE_TYPES.direction;
}

export function audioTextForPrompt(prompt = {}, requestedChannel) {
  const voiceType = voiceTypeForPrompt(prompt, requestedChannel);
  if (voiceType === VOICE_TYPES.dialogue) return prompt.dialogueText || prompt.text || '';
  return prompt.directionText || prompt.text || '';
}

export function audioChannelsForPrompt(prompt = {}) {
  if (prompt.directionCaptionOnly) return !prompt.suppressOwnDialogue && prompt.dialogueText ? [{voiceType:VOICE_TYPES.dialogue,text:prompt.dialogueText}] : [];
  if (prompt.suppressOwnDialogue === true) return prompt.directionText ? [{ voiceType: VOICE_TYPES.direction, text: prompt.directionText }] : [];
  if (prompt.directionText && prompt.dialogueText) {
    return [
      { voiceType: VOICE_TYPES.direction, text: prompt.directionText },
      { voiceType: VOICE_TYPES.dialogue, text: prompt.dialogueText },
    ];
  }
  const voiceType = voiceTypeForPrompt(prompt);
  return [{ voiceType, text: audioTextForPrompt(prompt, voiceType) }];
}
